import "./DesktopTrafficTypes.css";
import { useLang } from "../../../../i18n/LangContext";
import cpiIcon from "../../../../assets/desktopAdvertise/traffic/cpi.svg";
import cpeIcon from "../../../../assets/desktopAdvertise/traffic/cpe.svg";
import cpcIcon from "../../../../assets/desktopAdvertise/traffic/cpc.svg";
import cpaIcon from "../../../../assets/desktopAdvertise/traffic/cpa.svg";

const icons = [cpiIcon, cpeIcon, cpcIcon, cpaIcon];

export default function DesktopTrafficTypes({ id = "faq" }) {
  const { t } = useLang();
  const data = t?.advertiseTraffic;
  if (!data) return null;

  return (
    <section id={id} className="traffic-root traffic-desktop" aria-label="Traffic types">
      <div className="traffic-wrap">
        <header className="traffic-head">
          <p className="traffic-eyebrow">{data.eyebrow}</p>
          <h2 className="traffic-title">
            {data.titleLine1}<br />{data.titleLine2}
          </h2>
        </header>

        <div className="traffic-grid">
          {data.cards?.slice(0, 4).map((card, index) => (
            <article key={card.title} className="traffic-card">
              <span className="traffic-dot traffic-dot--top" aria-hidden="true" />

              <div className="traffic-icon-wrap" aria-hidden={icons[index] ? "false" : "true"}>
                <div className="traffic-icon-ring-main">
                  <div className="traffic-icon-ring">
                    {icons[index] ? (
                      <img
                        src={icons[index]}
                        alt={card.iconAlt || card.title}
                        className="traffic-icon-img"
                        loading="lazy"
                      />
                    ) : (
                      <div className="traffic-icon-ph" />
                    )}
                  </div>
                </div>
              </div>

              <header className="traffic-card-head">
                <h3 className="traffic-card-title">{card.title}</h3>
                {card.subtitle && <p className="traffic-card-kicker">{card.subtitle}</p>}
              </header>

              <p className="traffic-card-desc">{card.text}</p>

              <span className="traffic-dot traffic-dot--bottom" aria-hidden="true" />
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
